import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import EditVehicleFormik from '../../../containers/vehicles/EditVehicleFormik'
import EditProductsPane from '../../../containers/vehicles/EditProductsPane'
import Accommodations from '../../../containers/vehicles/Accomodations'
import AccessAndCapacity from '../../../containers/vehicles/AccessAndCapacity'
import EditVehicleNav from './EditVehicleNav'

const EditVehiclePane = (props: RouteComponentProps) => {
  const routeParts = props.location.pathname.split('/')
  const vehicleId = routeParts[3]
  return (
    <div>
      <div className='w100'>
        <div className='p2 pt1 col-12 border-top'>
          <span className='h3 font-grey2'>Edit Vehicle</span>
        </div>
      </div>

      <EditVehicleNav currentPath={props.match.url} pathname={props.location.pathname} vehicleId={vehicleId} />

      <Switch>
        <Route path={`${props.match.path}/:id/details`} component={EditVehicleFormik} />
        <Route
          path={`${props.match.path}/:id/products`}
          component={EditProductsPane(`/vehicles/edit/${vehicleId}/access-capacity`)}
        />
        <Route
          path={`${props.match.path}/:id/access-capacity`}
          component={AccessAndCapacity(`/vehicles/edit/${vehicleId}/accommodations`)}
        />
        <Route path={`${props.match.path}/:id/accommodations`} component={Accommodations} />
      </Switch>
    </div>
  )
}

export default EditVehiclePane



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/EditVehiclePane.tsx